
import React, { useState } from 'react';

export default function ContactSection() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
    terms: false
  });

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.terms) {
      alert('Пожалуйста, примите условия обслуживания.');
      return;
    }
    // Здесь можно отправить данные на сервер
    console.log('Submitted:', form);
    alert('Ваша заявка отправлена!');
    setForm({ name: '', email: '', message: '', terms: false });
  };

  return (
    <section id='apply' className="contact-section">
      <div className="contact-container">
        {/* Левая колонка: форма */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2 className="contact-form__title">Связаться с нами</h2>

          <label>
            Имя
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Введите свое имя"
              required
            />
          </label>

          <label>
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Введите действительный адрес электронной почты"
              required
            />
          </label>

          <label>
            Сообщение
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Ваше сообщение"
              required
            />
          </label>

          <label className="contact-form__terms">
            <input
              type="checkbox"
              name="terms"
              checked={form.terms}
              onChange={handleChange}
            />
            I accept the Terms of Service
          </label>

          <button type="submit" className="btn btn--primary btn--large">
            ОТПРАВИТЬ НА РАССМОТРЕНИЕ
          </button>
        </form>

        {/* Правая колонка: контактная информация */}
        <div className="contact-info">
          <h3 className="contact-info__title">Контакты</h3>
          <p>
            <strong>Email:</strong> info@umaukras.com
          </p>
          <p>
            <strong>Телефон:</strong> +380 67 775 85 61
          </p>
          <p>
            <strong>Сайт:</strong> uam.in.ua
          </p>
          <p>
            <strong>Адрес:</strong> г. Киев, просп. Берестейский, 54/1
          </p>
        </div>
      </div>
    </section>
);
}
